import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { handleEventGoogle } from 'models/shared/helpers/googleAnalytics';

// icons
import { ReactComponent as Boy } from 'design_system/src/static/icons/boy.svg';

import { ReactComponent as Lock } from 'design_system/src/static/icons/lock-square.svg';
import { Button, Input, Typography } from 'design_system/src';

import {
	clearLastUrl,
	getLastUrl,
	setUser,
	setToken,
	setRefreshToken,
} from 'localStorage/authStorage';
// css
import './auth.scss';
import {
	authLogin,
	fetchProfile,
} from 'models/auth/controllers/auth.controller';
import { LoginResponse } from 'models/auth/interfaces/auth.interface';
import { CompanyRole } from 'models/companies/enums/companies.enums';
import { getPostLoginPath } from 'models/shared/helpers/postLoginRedirect';

const validationSchema = yup.object({
	email: yup.string().email('Email inválido').required('Campo requerido'),
	password: yup.string().required('Campo requerido'),
});

function Auth({ type }: { type: CompanyRole }) {
	useEffect(() => {
		handleEventGoogle(
			'VIEW_SauronControlTower_login',
			'SauronControlTower',
			'page view to login view',
		);
	}, []);
	const navigate = useNavigate();
	const [loading, setloading] = useState<boolean>(false);

	const login = (value: { email: string; password: string }) => {
		setloading(true);
		authLogin(value)
			.then((res: LoginResponse) => {
				setToken(res.access_token);
				if (res.refresh_token) {
					setRefreshToken(res.refresh_token);
				}
				return fetchProfile(res.access_token);
			})
			.then((prof) => {
				setloading(false);
				setUser(prof);
				const postLoginPath = getPostLoginPath(prof);
				const lastUrl = getLastUrl();
				if (lastUrl) {
					clearLastUrl();
					try {
						const lastPath = new URL(lastUrl, window.location.origin).pathname;
						// Solo restaurar lastUrl si pertenece al mismo árbol de rutas del usuario
						// eslint-disable-next-line no-restricted-globals
						location.href = lastPath.startsWith(postLoginPath)
							? lastUrl
							: postLoginPath;
					} catch {
						navigate(postLoginPath);
					}
				} else {
					navigate(postLoginPath);
				}
			})
			.catch(() => {
				setloading(false);
				Swal.fire({
					title: 'Error!',
					text: 'Usuario o contraseña incorrecta',
					icon: 'error',
					confirmButtonText: 'Aceptar',
				});
			});
	};

	const formik = useFormik({
		initialValues: {
			email: '',
			password: '',
		},
		validationSchema,
		onSubmit: login,
	});

	return (
		<div className="root flex_center">
			<div
				className="
        dso_card 
        login_card 
        p_xxl 
        shadow_hard"
			>
				<img
					alt="Logo"
					src={`${process.env.PUBLIC_URL || ''}/sauron-logo.png`}
					className="logo center_x m_b_xxl"
				/>
				<form onSubmit={formik.handleSubmit}>
					<Typography
						scale="medium"
						weight="600"
						className=" m_b_md text_center"
						textColor="neutral_0"
					>
						LOGIN
					</Typography>

					<Input
						title="Email"
						type="email"
						name="email"
						placeholder="Escriba su email aquí"
						value={formik.values.email}
						onChange={formik.handleChange}
						icon={<Boy />}
						className="m_b_md dso_width_100_per"
					/>
					<Input
						title="Contraseña"
						type="password"
						name="password"
						placeholder="Escriba su contraseña aquí"
						value={formik.values.password}
						onChange={formik.handleChange}
						icon={<Lock />}
						className="m_b_xxl dso_width_100_per"
					/>
					<Button
						type="submit"
						disabled={loading || !formik.isValid}
						scale="small"
						className="w_100_per m_b_md m_t_xxs"
						icon={<Boy />}
					>
						{loading ? <CircularProgress className="loading" /> : 'Ingresar'}
					</Button>
				</form>
			</div>
		</div>
	);
}

export default Auth;
